<template>
  <transition name="fade" mode="out-in">
    <div
        v-if="locations.length"
        key="1"
        class="layout gap-2"
        selenium="city-modal-container">
      <div
          v-for="(location, index) in locations"
          :key="location.city"
          class="layout-item is-12 is-6:t">
        <button
            :selenium="`city-name-button:${index + 1}`"
            class="btn-secondary w-100 p-r-5 p-l-5"
            @click="choose(location)">
          {{ location.city }}, {{ location.state }}
        </button>
      </div>
    </div>
    <div v-else key="2">
      <spinner class="m-x-auto"/>
    </div>
  </transition>
</template>

<script>
import { getCities } from '@homeservices/api-kit/search';

export default {
  name: 'choose-city-and-state',
  props: {
    zipcode: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      locations: [],
    };
  },
  watch: {
    zipcode: {
      handler (value) {
        // TODO(adam): this api request needs to be cancellable

        return getCities('US', value)
          .then((response) => {
            if (response.data.results.length === 1) {
              this.choose(response.data.results[0]);
            } else if (response.data.results.length > 1) {
              this.locations = response.data.results;
            }
          })
          .catch(() => {
            // do nothing
          });
      },
      immediate: true,
    },
  },
  methods: {
    choose (location) {
      this.$emit('location-chosen', {
        zipcode: location.zipcode,
        city: location.city,
        state: location.state,
      });
    },
  },
};
</script>
